module.exports = __webpack_public_path__ + "static/media/property-management-fr.b4cc4285.png";